import React from 'react';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Las Primeras Palabras',
    hook: '👉 Estimulá el lenguaje en el día a día',
    bullets: ['Primeras palabras en contexto real', 'Mini juegos sensoriales', 'Frases listas para usar'],
    img: 'https://cdn.magicpatterns.com/uploads/3JmdW8eXdvZPVLytwBj9QA/image.png'
  }, {
    num: 2,
    title: 'Kit de Números y Grafomotricidad',
    hook: '👉 Aprende números y desarrolla coordinación jugando',
    bullets: ['+48 páginas imprimibles', 'Conteo', 'Trazos', 'Coordinación ojo-mano'],
    img: 'https://cdn.magicpatterns.com/uploads/9qZFme73g91FbxzpPt6RhG/image.png'
  }, {
    num: 3,
    title: 'Kit de Observación y Coordinación',
    hook: '👉 Desarrolla atención, lógica y motricidad fina',
    bullets: ['Actividades visuales', 'Asociación', 'Resolución de problemas', 'Juegos de observación'],
    img: 'https://cdn.magicpatterns.com/uploads/sMET64sKxuH6SUUEyK9qUq/image.png'
  }, {
    num: 4,
    title: 'Guía Práctica para Padres',
    hook: '👉 Cómo acompañarlo en cada etapa',
    bullets: ['Rutinas tranquilas', 'Comunicación positiva', 'Manejo emocional', 'Autonomía infantil'],
    img: 'https://cdn.magicpatterns.com/uploads/7DMQbzenHx2HCUeqiXfNL6/image.png'
  }, {
    num: 5,
    title: 'Planificador Familiar Imprimible',
    hook: '👉 Organizá tu rutina sin estrés',
    bullets: ['Planificadores diarios y semanales', 'Calendarios', 'Seguimiento de hábitos', 'Espacio para notas y objetivos'],
    img: 'https://cdn.magicpatterns.com/uploads/vebckwcQiyfHF5uHUuFLhn/image.png'
  }];
  return <section className="bg-gray-50 py-16 px-4 sm:px-6 border-t border-gray-200" data-id="element-39">
      <div className="max-w-4xl mx-auto space-y-10" data-id="element-40">
        <div className="text-center space-y-4" data-id="element-41">
          <span className="text-6xl block mb-4" data-id="element-42">🎁</span>
          <h2 className="font-archivo text-3xl sm:text-4xl md:text-5xl uppercase text-brand-red leading-tight" data-id="element-43">
            HOY TAMBIÉN RECIBÍS 5 BONUS EXCLUSIVOS
          </h2>
          <p className="text-base sm:text-lg font-bold text-brand-black bg-brand-yellow inline-block px-5 py-2 rounded-full" data-id="element-44">
            GRATIS POR EL DÍA DE HOY — Valor $67.000
          </p>
        </div>

        <div className="space-y-6" data-id="element-45">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white rounded-2xl overflow-hidden shadow-md border-2 border-gray-100 flex flex-row items-stretch" data-id="element-46">
              <a href="https://impulsodigital.vip/cart/44763616936022:1" className="block cursor-pointer hover:opacity-95 transition-opacity relative shrink-0 w-28 sm:w-40 md:w-48 bg-gray-100" data-id="element-47">
                <div className="absolute top-1.5 left-1.5 bg-brand-red text-white font-archivo text-[10px] sm:text-xs px-2 py-0.5 rounded shadow-md z-10" data-id="element-48">
                  BONUS {bonus.num}
                </div>
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-49" />
              </a>

              <div className="p-4 sm:p-6 flex-1 flex flex-col justify-center space-y-2 sm:space-y-3" data-id="element-50">
                <h3 className="font-archivo text-base sm:text-xl md:text-2xl uppercase text-brand-black leading-tight" data-id="element-51">
                  {bonus.title}
                </h3>
                <p className="text-xs sm:text-sm md:text-base font-bold text-gray-700" data-id="element-52">
                  {bonus.hook}
                </p>
                <ul className="space-y-1 sm:space-y-1.5" data-id="element-53">
                  {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2 text-xs sm:text-sm md:text-base font-medium text-gray-600" data-id="element-54">
                      <span className="text-brand-green shrink-0" data-id="element-55">✔</span>
                      {bullet}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}